import { render, staticRenderFns } from "./channelOpe2.vue?vue&type=template&id=528437ea&scoped=true&"
import script from "./channelOpe2.vue?vue&type=script&lang=js&"
export * from "./channelOpe2.vue?vue&type=script&lang=js&"
import style0 from "./channelOpe2.vue?vue&type=style&index=0&id=528437ea&lang=scss&scoped=true&"
import style1 from "./channelOpe2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528437ea",
  null
  
)

export default component.exports